export default {
  utility: {
    green: {
      default: '#61cc71',
      lightest: '#aeffbe',
      dark: '#54d326'
    },
    white: {
      default: '#ffffff'
    },
    blue: {
      default: '#2eb5ff',
      lightest: '#7bffff'
    },
    yellow: {
      default: '#ffcd67',
      lightest: '#ffffb4'
    },
    red: {
      default: '#c94646',
      lightest: '#ecbcbc'
    }
  },
  purple: {
    default: '#201849',
    light: '#453f6b',
    lighter: '#736d91',
    lightest: '#bab7cc',
    darker: '#01476f',
    darkest: '#00466E'
  },
  blue: {
    darkest: '#003c5d',
    darker: '#016aa3',
    dark: '#0087d6',
    default: '#00B7FF',  //'#00a5ff',
    light: '#2eb5ff',
    lighter: '#5cc5ff',
    lightest: '#b9e6ff'
  },
  orange: {
    default: '#fca664',
    light: '#ffb077',
    lighter: '#ffc296',
    lightest: '#ffddba'
  },
  floral: {
    darker: '#e9e3d7',
    dark: '#f2eee6',
    default: '#fefaf2'
  },
  neutro: {
    dark: '#000',
    light: '#fff'
  },
  sella: {
    dark: '#072030',
    light: '#f7e53b'
  },
  yooxYellow: {
    dark: '#fe7b10',
    default: '#fae32f',
    lightest: 'rgba(254, 123, 16, 0.7)'
  },
  yooxBlack: {
    darker: '#333333',
    dark: '#333333',
    default: '#333333',
    light: '#848484',
    lighter: '#cbcbcb',
    lightest: '#f3f3f3'
  },
  timRed: {
    darker: '#960028',
    dark: '#c80028',
    default: '#eb0028',
    light: '#ff825a'
  },
  timBlue: {
    dark: '#003264',
    default: '#376ea5',
    light: '#004691',
    lighter: '#1680C3',
    lightest: '#82b9e6'
  },
  timGray: {
    default: '#d8d8d8'
  },
  gray: {
    default: '#f8f9fa',
    light: '#cecece'
  }
}



// WEBPACK FOOTER //
// ./styles/settings/colors.js